/** Decode only raster uploads and keep new profile images within a 320px square. */
export async function profileImage(file: File): Promise<string> {
  if (!/^image\/(png|jpeg|webp)$/.test(file.type) || file.size > 1_000_000) throw new Error("INVALID_IMAGE");
  const image = await createImageBitmap(file);
  try {
    if (!image.width || !image.height || image.width * image.height > 16_000_000) throw new Error("INVALID_IMAGE");
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = 320;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("INVALID_IMAGE");
    const side = Math.min(image.width, image.height);
    context.drawImage(image, (image.width - side) / 2, (image.height - side) / 2, side, side, 0, 0, 320, 320);
    const result = canvas.toDataURL("image/webp", .8);
    if (result.length > 1_500_000) throw new Error("INVALID_IMAGE");
    return result;
  } finally { image.close(); }
}
